// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qQY7","inner":"Form_inner__IC7Fg","range":"Form_range__v0eYe","name":"Form_name__27Pqf","actions":"Form_actions__ELrnD"};